import { StocksDeactivatingDataComponent } from './deactivate-data';

export const STOCKDEACTIVATECOMPONENT_DECLARATIONS: any[] = [StocksDeactivatingDataComponent];